module.exports = __webpack_public_path__ + "static/media/badge-node-js.1898c712.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-node-js.png
// module id = 295
// module chunks = 0